import React from 'react';
import styles from './DropdownMenu.module.scss';

interface DropdownItem {
  label: string;
  value: string;
}

interface DropdownMenuProps {
  items: DropdownItem[];
  selectedItem: string;
  onSelect: (item: string) => void;
  isVisible: boolean;
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({
  items,
  selectedItem,
  onSelect,
  isVisible,
}) => {
  if (!isVisible) return null;

  return (
    <div className={`dropdown_container ${styles.dropdown_container} `}>
      <div className={`dropdown_menu ${styles.dropdown_menu}`}>
        {items.map((item) => (
          <div
            key={item.value}
            className={`
              ${styles._dropdown_item} 
            `}
            onClick={() => onSelect(item.value)}
          >
            {item.label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DropdownMenu;
